// extracted by mini-css-extract-plugin
export var inputContainer = "_so-0";